import styled from "styled-components";

export const SummaryWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  border-top: 1px solid #2d2e30;
  margin-top: 40px;
  padding-top: 30px;

  label {
    margin: 0;
    font-family: "Roboto Mono";
    /* display: block; */
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 300;
    color: white;
  }
`;

export const SummaryWrapperNumber = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  span {
    font-family: "Roboto Mono";
    margin-right: auto;
    color: #ff5000;
    align-self: flex-end;
    margin-bottom: 10px;
    white-space: nowrap;
  }

  > span {
    color: #7f7f7f;
  }

  button {
    height: 50px;
    align-self: flex-end;
    margin-bottom: 10px;

    @media (max-width: 767.98px) {
      height: auto;
      width: 100%;
      margin-top: 30px;
    }
  }
`;
